import Components from 'slotworks/components/components';
import AbstractMediator from 'slotworks/mediators/abstract-mediator';
import Bet from 'slotworks/model/bets/bet-model';
import GameState from 'slotworks/model/game-state';
import FreespinRecord from 'slotworks/model/gameplay/records/freespin-record';
import Contract from 'slotworks/utils/contract';
import GameInit from 'states/game-init';

export default class BigWinMediator extends AbstractMediator {
    public start(): Contract<boolean> {
        let winnings = GameState.getCurrentGame().getCurrentRecord().creditsWon;
        if (GameState.getCurrentGame().getCurrentRecord() instanceof FreespinRecord) {
            winnings = GameInit.freeSpinsWin;
        }
        const stake = GameState.getCurrentGame().isBuyout ? GameState.getCurrentGame().totalBet : Bet.getTotalBet();
        return Components.bigWin.showWin(winnings, stake);
    }
}



// WEBPACK FOOTER //
// ./src/mediator/big-win-mediator.ts